declare const $:any;
declare const STORELIST_FORM:any;

export class contactForm{

	constructor(){

		jQuery(".MainNav a[href='#contact-us']").click(function(e){
			e.preventDefault();
			jQuery("#contac-us-modal").openModal();
		});



		jQuery(".side-nav a[href='#contact-us']").click(function(e){
			e.preventDefault();
			jQuery("#sidenav-overlay").click();
			jQuery("#contac-us-modal").openModal();
		});

		jQuery(".rmradio li").click(function(e){
			jQuery(this).find("input").click();
		});

		jQuery(".rmradio li input").click(function(e){
			e.stopPropagation();
		});


		//POPULATE STORES OPTIONS WITH JAVASCRIPT

		//var $storelist_form = jQuery(".store_select_field select");

		// if($storelist_form.length && typeof STORELIST_FORM != 'undefined'){
		// 	$storelist_form.find("option").remove();
		// 	for (var i=0; i < STORELIST_FORM.length; i++) {
		// 		var store = STORELIST_FORM[i];
		// 		$storelist_form.append("<option value='"+store["store_keyloc"] +" - "+store["store_name"]
		// 			+"'>"+store["store_name"]+"</option>")
		// 	}
		// 	$storelist_form.find("option:first").prop("select",true).attr("select",true);
		// 	$storelist_form.material_select();
		// }


		var $form_error = jQuery(".gform_wrapper > form > .validation_error");
		if($form_error.length){
			jQuery("html,body").animate({scrollTop: $form_error.offset().top- 100}, 500, 'swing');
		}


		var $confirmation = jQuery(".gform_confirmation_message");
		if($confirmation.length){
			jQuery("html,body").animate({scrollTop: $confirmation.offset().top- 100}, 500, 'swing');
		}
	}
}
